export class FormatUtils {
  static formatMoney(amount: number, decimalCount = 2, decimal = '.', thousands = ',') {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substring(0, j) + thousands : '') +
      i.substring(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - parseInt(i))
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  }

  static formatCardNumber(number: string | number | undefined): string | null {
    if (!number) return null;

    const numStr = number.toString();
    return numStr.replace(/(.{4})/g, '$1 ').trim();
  }
}
